export const COOKIE_MODAL_STEP = {
  INTRO: "intro",
  PERSONALIZE: "personalize"
};

export const COOKIE_CONSENT_SECTION = {
  ESSENTIAL: "essential",
  ANALYTICS: "analytics",
  MARKETING: "marketing"
};

export const COOKIE_CONSENT_SECTIONS = [
  {
    id: COOKIE_CONSENT_SECTION.ESSENTIAL,
    titleKey: "cookie_section_essential",
    alwaysActive: true,
    keys: ["functionality_storage", "security_storage"]
  },
  {
    id: COOKIE_CONSENT_SECTION.ANALYTICS,
    titleKey: "cookie_section_analytics",
    items: [
      {
        key: "analytics_storage",
        labelKey: "cookie_option_analytics_storage"
      },
      {
        key: "personalization_storage",
        labelKey: "cookie_option_personalization_storage"
      }
    ]
  },
  {
    id: COOKIE_CONSENT_SECTION.MARKETING,
    titleKey: "cookie_section_marketing",
    items: [
      {
        key: "ad_user_data",
        labelKey: "cookie_option_ad_user_data"
      },
      {
        key: "ad_personalization",
        labelKey: "cookie_option_ad_personalization"
      },
      {
        key: "ad_storage",
        labelKey: "cookie_option_ad_storage"
      }
    ]
  }
];
